import { render, staticRenderFns } from "./lists.vue?vue&type=template&id=1d33666a&"
import script from "./lists.vue?vue&type=script&lang=ts&"
export * from "./lists.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/forge/aef.slmndr.be/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1d33666a')) {
      api.createRecord('1d33666a', component.options)
    } else {
      api.reload('1d33666a', component.options)
    }
    module.hot.accept("./lists.vue?vue&type=template&id=1d33666a&", function () {
      api.rerender('1d33666a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/projects/lists.vue"
export default component.exports